export const SelfieIcon = () => (
  <svg
    className="security-icon"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M5 20C5 16.69 8.13 14 12 14C15.87 14 19 16.69 19 20"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
